import { createAsyncThunk } from '@reduxjs/toolkit'

import { callErrorMsg } from 'helpers/errorMsg'
import {
  getVendorDataSKP,
  getIdUser,
  putVendorDataSKP,
  PutVendorDataSKPPayloadType,
} from 'features/Enterprise/Vendor/services/vendorDataSKP'
import { getVendorDetails } from 'features/Enterprise/Vendor/services/addEditVendor'
import { getQueryParamsObjectToString } from 'utils/helpers/router'

import {
  sliceName,
  setLoading,
  setVendorSKPForm,
  setIsNewData,
  setVendorName,
  resetVendorSKPForm,
} from './vendorSKPDataSlice'

export const fetchVendorDataSKP = createAsyncThunk(
  `${sliceName}/fetchVendorDataSKP`,
  async (vendorId: number, { dispatch }) => {
    dispatch(setLoading(true))
    try {
      const response = await getVendorDataSKP(vendorId)
      const { data: vendorSKPData } = response.data

      if (vendorSKPData) {
        dispatch(setVendorSKPForm(vendorSKPData))
        dispatch(setIsNewData(false))
      } else {
        dispatch(resetVendorSKPForm())
        dispatch(setIsNewData(true))
      }

      return
    } catch (error) {
      throw callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)

export const fetchVendorDetails = createAsyncThunk(
  `${sliceName}/fetchVendorDetails`,
  async (vendor_id: string, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await getVendorDetails(vendor_id)
      dispatch(setVendorName(data.data.name))
      return false
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchIdUser = createAsyncThunk(`${sliceName}/fetchIdUser`, async (name: string) => {
  try {
    const parseQuery = getQueryParamsObjectToString({ name, page_size: '20', page_index: '0' })
    const response = await getIdUser(parseQuery)
    return response.data.data.users
  } catch (error) {
    throw callErrorMsg(error)
  }
})

export const insertVendorDataSKP = createAsyncThunk(
  `${sliceName}/insertVendorDataSKP`,
  async (payload: PutVendorDataSKPPayloadType & { vendor_id: number }) => {
    try {
      const { vendor_id, ...restPayload } = payload
      const response = await putVendorDataSKP(vendor_id, restPayload)
      const { error } = response.data

      if (error.status) {
        throw callErrorMsg(error.message)
      }

      return true
    } catch (error) {
      throw callErrorMsg(error)
    }
  },
)
